export default {"src":"/_next/static/media/arcticons_mobility.28e65d93.svg","height":33,"width":59,"blurWidth":0,"blurHeight":0};